import { ApiError } from '@anm/api';
import { Folder } from '@anm/api/modules/videoFolder';
import getHashByObject from '@anm/helpers/get/getHashByObject';
import resizeWithAspectRatio from '@anm/helpers/size/resizeWithAspectRatio';
import { AnimatronProject } from 'project';

import ImageProject from '../ImageProject';
import { ProjectFolderBlockMemorized } from '../ProjectFolderBlock';
import ProjectPlayerBlock from '../ProjectPlayerBlock';

type RenderItemProps = {
  canFocusField: boolean;
  onCanFocusField: (canFocus: boolean) => void;
};

export const createFolderAndProjectList = (folders: Folder[], projects: AnimatronProject[]) => [
  ...folders.map(folder => {
    const { id, parentId, name, modified, preview, isRenamed } = folder;
    return {
      id,
      key: getHashByObject(folder),
      height: 400,
      renderItem: ({ onCanFocusField, canFocusField }: RenderItemProps) => (
        <ProjectFolderBlockMemorized
          title={name}
          preview={preview}
          folderId={id}
          parentId={parentId!}
          modified={modified}
          isRenamed={isRenamed}
          canFocusField={canFocusField}
          onCanFocusField={onCanFocusField}
        />
      )
    };
  }),
  ...projects.map(project => {
    const {
      id,
      name,
      width,
      extra,
      height,
      isDraft,
      version,
      isLanding,
      isProtected,
      isEmbedded,
      modified,
      duration,
      hasTemplate,
      canStreamVideo,
      shouldUpdatePreview
    } = project;

    return {
      id,
      name,
      key: getHashByObject(project),
      height: resizeWithAspectRatio(width, height, 280).height,
      renderItem: () =>
        extra.kind === 'image' ? (
          <ImageProject
            title={name}
            projectId={id}
            hasTag={hasTemplate}
            hostId={extra?.hostingId}
            width={extra?.hostedWidth || width}
            height={extra?.hostedHeight || height}
            {...{ version, modified, shouldUpdatePreview }}
          />
        ) : (
          <ProjectPlayerBlock
            title={name}
            projectId={id}
            hasTag={hasTemplate}
            streamId={extra?.streams ? extra.streams[0] : null}
            canEdit={!extra?.streams}
            hostId={extra?.hostingId}
            width={extra?.hostedWidth || width}
            height={extra?.hostedHeight || height}
            statuses={{ isEmbedded, isDraft, isLanding, isProtected }}
            duration={extra?.hostedDuration || duration}
            {...{ version, modified, canStreamVideo, shouldUpdatePreview }}
          />
        )
    };
  })
];

export const isNotFoundErrorCode = (error?: ApiError | null) => error && error.code === 404;
